import { useUserInfo } from "@next-platform/client-common-core";

const MAX_MEMBERS_BY_ROLE: Record<string, number> = {
  paid_premium: 10,
  paid_basic: 10,
  paid_minimal: 10,
  free_tier: 10,
  employee: 10,
};

export const useMaxGroupMembers = () => {
  const { role } = useUserInfo();

  const maxMembers = MAX_MEMBERS_BY_ROLE[role] || 10;

  return { maxMembers };
};
